export const INTEGRATE_KIBO =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/KIBO/INTEGRATE'
export const INTEGRATE_KIBO_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/KIBO/INTEGRATE_SUCCESS'
export const INTEGRATE_KIBO_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/ECOMMERCE/KIBO/INTEGRATE_ERROR'
